<span class="InspectionStatus">
  <mat-icon
    class="material-symbols-outlined"
    matTooltip="{{
      'inspections.status.' + inspection.status + '.text' | enum
    }}"
    >{{ 'inspections.status.' + inspection.status + '.icon' | enum }}</mat-icon
  >
  <span>
    {{ 'inspections.status.' + inspection.status + '.text' | enum }}
  </span>
</span>
